import gsap from 'gsap'

import {
  buttonRevealAnimation,
  getScrollTriggerOptions,
  linesRevealAnimation,
  paragraphRevealAnimation,
  SharedAnimation
} from './shared'
import { Animation } from '@/types'

export const heroParagraphRevealAnimation = ({
  node,
  mobile,
  context,
  reverse
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const mask = selector('[data-motion-mask]')[0]
  mask && gsap.to(mask, { opacity: 0, duration: 0.5, ease: 'power2.inOut' })

  if (mobile) return

  const title = selector('[data-motion-title]')[0]
  const button = selector('[data-motion-button]')[0]
  const overline = selector('[data-motion-overline]')[0]
  const paragraph = selector('[data-motion-paragraph]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    onComplete: () => mask?.remove()
  })

  let overlineAnimation: SharedAnimation
  if (overline) {
    overlineAnimation = linesRevealAnimation(overline, reverse)
    timeline.add(overlineAnimation.timeline, '<')
  }

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, '<')
  }

  let paragraphAnimation: SharedAnimation
  if (paragraph) {
    paragraphAnimation = paragraphRevealAnimation(paragraph, reverse)
    timeline.add(paragraphAnimation.timeline, '<+0.2')
  }

  let buttonAnimation: SharedAnimation
  if (button) {
    buttonAnimation = buttonRevealAnimation(button)
    timeline.add(buttonAnimation.timeline, '<+0.4')
  }

  return () => {
    timeline.kill()

    titleAnimation?.revert()
    overlineAnimation?.revert()
    paragraphAnimation?.revert()
    buttonAnimation?.revert()
  }
}
